export const FREE_PLAN_TASKS_LIMIT = 300;
export const FREE_PLAN_PROJECTS_LIMIT = 3;

export const PLATE_BOT_NAME = 'plate';
export const PLATE_BOT_AVATAR = 'https://firebasestorage.googleapis.com/v0/b/plate-491208.firebasestorage.app/o/attachments%2FExkw8nFpYwHqtwff3QPB%2FPCrn67gtvEDObefJLSYA?alt=media&token=ad2e59b7-a97c-4736-81c7-3c835f14c48c';

// The built-in AI agent — a synthetic workspace member (no Firebase Auth account).
// Must match AGENT_USER_ID / AGENT_NAME in functions/src/domain/agent/agentConstants.ts.
export const AGENT_USER_ID = 'plate-agent';
export const AGENT_NAME = 'plate';